import React, { Component } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as CommentSVG } from "../images/svg/comment.svg";
import { ReactComponent as BookmarkSVG } from "../images/svg/bookmark.svg";
import { ReactComponent as LikeSVG } from "../images/svg/like.svg";
import { ReactComponent as PinSVG } from "../images/svg/pin.svg";
import CountSetter from "../helpers/CountSetter";
import store from "../store";
import { notif } from "../helpers/helperFunc";

class Posts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      requestSent: false
    };

    this.article = this.article.bind(this);
    this.audio = this.audio.bind(this);
    this.renderPosts = this.renderPosts.bind(this);

    this.toggleBookmark = this.toggleBookmark.bind(this);
    this.togglePin = this.togglePin.bind(this);

    this.handleOnScroll = this.handleOnScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleOnScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleOnScroll);
  }

  handleOnScroll() {
    const elemWrapper = document.querySelector("#post-lists");
    let scrollTop = window.pageYOffset;
    let scrollHeight = elemWrapper.scrollHeight;
    let clientHeight = elemWrapper.clientHeight;

    let scrollPosition =
      Math.ceil(scrollTop + clientHeight - 500) >= scrollHeight;
    if (scrollPosition) {
      this.props.beforeListFetch();
    }
  }

  toggleBookmark = postID => e => {
    if (
      !notif(
        parseInt(store.getState().columnOne.details.user_id) > 0,
        "Please Login To Your Account"
      )
    )
      return;
    if (e.target.tagName === "svg") {
      console.log(e.target.tagName);
      let elem = e.target.parentElement;
      if (elem.classList.contains("neutral")) {
        elem.classList.remove("neutral");
        elem.classList.add("upvote");
        e.target.style.fill = 'green';
        elem.classList.add("bounce");
        elem.classList.add("animated");
      } else {
        e.target.style.fill = '#525252';
        elem.classList.add("neutral");
        elem.classList.remove("upvote");
        elem.classList.remove("bounce");
        elem.classList.remove("animated");
      }
    } else {
      return;
    }

    fetch(`${this.props.apiROOT}bookmark/add/${postID}`)
      .then(res => res.json())
      .then(data => {
        if (data.status === true) {
          store.getState().columnOne.details.bookmark_count =
            data.bookmarkCount;
          if (document.querySelector(".c1-bookmark-count span")) {
            document.querySelector(".c1-bookmark-count span").innerHTML =
              data.bookmarkCount;
          }

          if (document.querySelector(".user-bookmark-count span")) {
            document.querySelector(".user-bookmark-count span").innerHTML =
              data.bookmarkCount;
          }
        }
      });
  }

  togglePin = (postID, pinned) => e => {
    if (
      !notif(
        parseInt(store.getState().columnOne.details.user_id) > 0,
        "Please Login To Your Account"
      )
    )
      return;
    if (e.target.tagName === "svg") {
      let elem = e.target.parentElement;
      if (elem.classList.contains("neutral")) {
        elem.classList.remove("neutral");
        e.target.style.fill = 'green';
        elem.classList.add("upvote");
        elem.classList.add("bounce");
        elem.classList.add("animated");
      } else {
        e.target.style.fill = '#525252';
        elem.classList.add("neutral");
        elem.classList.remove("upvote");
        elem.classList.remove("bounce");
        elem.classList.remove("animated");
      }
    } else {
      return;
    }
    fetch(`${this.props.apiROOT}post/pin/${postID}/${pinned}`)
      .then(res => res.json())
      .then(data => {
        if (data.status === true) {
          //window.location.reload();
        }
      });
  }

  article(p) {
    return (
      <div className="c2-posts shadow-less" key={p.post_id}>
        <div className="c2-post">

          <div className="c2-post-in">
            <a href={`/post/${p.slug}-${p.post_id}`}>
              <p
                className="c2-post-title"
                dangerouslySetInnerHTML={{
                  __html: p.post_title
                }}
              ></p>
              <p
                className="c2-post-body"
                dangerouslySetInnerHTML={{
                  __html:
                    p.main_post.length > 200
                      ? p.main_post.substring(
                        0,
                        p.main_post
                          .replace(/<img src="([^]+)">/g, "")
                          .lastIndexOf(" ", 200)
                      )
                      : p.main_post.replace(/<img src="([^]+)">/g, "")
                }}
              >
                {}
              </p>
              ...read more
              {p.post_image !== "" && (
                <img
                  src={`${this.props.root}public/images/post_pic/${p.post_image}`}
                  alt={`${p.post_image}`}
                />
              )}
            </a>
          </div>
          <div className="c2-post-counts">
            <p className="c2-comment-count">
              <CommentSVG />
              <CountSetter count={p.post_comments} />
            </p>

            <p className="c2-upvote-count">

              <span
                className={
                  parseInt(store.getState().columnOne.details.user_id) > 0 &&
                    p.status > 0
                    ? "upvote"
                    : "neutral"
                }
              >
                <LikeSVG />
              </span>

              <CountSetter count={p.post_promotes} />
            </p>

            <p
              onClick={this.toggleBookmark(p.post_id)}
              id={`bookmark${p.post_id}`}
              className={`c2-bookmark ${
                parseInt(store.getState().columnOne.details.user_id) > 0 &&
                  parseInt(p.bookmark_id) > 0
                  ? "upvote"
                  : "neutral"
                }`}
            >
              <BookmarkSVG />
            </p>

            {parseInt(store.getState().columnOne.details.acl) > 0 &&
              <p

                style={
                  parseInt(store.getState().columnOne.details.user_id) > 0 &&
                    parseInt(p.pinned) > 0
                    ? { fill: 'green' }
                    : { fill: '#525252' }
                }
                onClick={this.togglePin(p.post_id, p.pinned)}
                id={`pin${p.post_id}`}
                className={`c2-pin ${
                  parseInt(store.getState().columnOne.details.user_id) > 0 &&
                    parseInt(p.pinned) > 0
                    ? "upvote"
                    : "neutral"
                  }`}
              >
                <PinSVG />
              </p>}
          </div>
        </div>
      </div>
    );
  }


  audio(p) {
    return (
      <div className="c2-posts shadow-less" key={p.post_id}>
        <div className="c2-post">

          <div className="c2-post-in">
            <a href={`#`}>
              <p
                className="c2-post-title">{p.post_title}</p>
              {p.post_image !== "" && (
                <p style={{maxHeight: 300}}>
                <img 
                  src={`${this.props.root}public/images/post_pic/${p.post_image}`}
                  alt={`${p.post_image}`}
                />
                </p>
              )}
              <p className="c2-post-body">
                <audio controls style={{width: 100+'%'}}>
                  <source src={`${this.props.root}public/audio/${p.audio}`} type="audio/ogg" />
                  <source src={`${this.props.root}public/audio/${p.audio}`} type="audio/flac" />
                  <source src={`${this.props.root}public/audio/${p.audio}`} type="audio/mp3" />
                  <source src={`${this.props.root}public/audio/${p.audio}`} type="audio/mpeg" />
                </audio>
              </p>

            </a>
          </div>
          <div className="c2-post-counts">
            <p
              onClick={this.toggleBookmark(p.post_id)}
              id={`bookmark${p.post_id}`}
              className={`c2-bookmark ${
                parseInt(store.getState().columnOne.details.user_id) > 0 &&
                  parseInt(p.bookmark_id) > 0
                  ? "upvote"
                  : "neutral"
                }`}
            >
              <BookmarkSVG />
            </p>

            {parseInt(store.getState().columnOne.details.acl) > 0 &&
              <p

                style={
                  parseInt(store.getState().columnOne.details.user_id) > 0 &&
                    parseInt(p.pinned) > 0
                    ? { fill: 'green' }
                    : { fill: '#525252' }
                }
                onClick={this.togglePin(p.post_id, p.pinned)}
                id={`pin${p.post_id}`}
                className={`c2-pin ${
                  parseInt(store.getState().columnOne.details.user_id) > 0 &&
                    parseInt(p.pinned) > 0
                    ? "upvote"
                    : "neutral"
                  }`}
              >
                <PinSVG />
              </p>}
          </div>
        </div>
      </div>
    );
  }

  renderPosts() {
    return this.props.posts.map(p => {
      if (p.post_type = 'Audio') {
        return this.audio(p)
      } else {
        return this.article(p);
      }
    });
  }

  render() {
    return (
      <React.Fragment>
        {this.state.redirect && window.open(`${this.props.root}login`, "_self")}
        <div id="post-lists">{this.renderPosts()}</div>
      </React.Fragment>
    );
  }
}

export default Posts;
